import React from "react";
import { useNavigate } from "react-router-dom";
/** Components Import */
import EmptyBox from "../../Components/EmptyBox";
import Card from "../../Components/Card_wrap";
import BasicArea from "../../Components/PDA/BarcodeArea";
import BasicInput from "../../Components/Input_Basic";
import BasicCombo from "../../Components/Combo_Basic";
import CardH3 from "../../Components/Card_H3";
import Snackbar from "../../Components/Snackbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleArrowRight as RightArrows,
  faClipboardCheck as OrderComplete,
  faHourglassHalf as StandBy,
  faBoxOpen as Producted,
  faBox as Packing,
  faTruckArrowRight as Delivery,
} from "@fortawesome/free-solid-svg-icons";
import BasicButton from "../../Components/Button_Basic";

function MM10070(props) {
  React.useEffect(() => {
    if (document.title === props.inputs.title) {
      return;
    } else {
      document.title = props.inputs.title;
      const element = document.getElementById("topbar");
      element.innerHTML =
        "<h1>" +
        "<span class='bullet'>" +
        "</span>" +
        "<strong class='depth-1'>" +
        "생산관리" +
        "	</strong>" +
        "<span class='divider' >" +
        "</span>" +
        "<strong'>" +
        props.inputs.title +
        "</strong>" +
        "</h1>";
    }
  }, []);
  React.useEffect(() => {
    const HandleEnterKey = (e) => {
      const { key, keyCode } = e;
      if (keyCode === 13) {
        navigator.clipboard.readText().then((clipboardText) => {
          if (
            clipboardText.substring(4, 6) === "WO" &&
            clipboardText.length === 10
          ) {
            props.WoNoSearch(clipboardText);
          } else {
            setSnackbars({
              toggle: true,
              type: "error",
              message: "Barcode번호를 확인해주세요",
            });
          }
        });
      }
    };
    window.addEventListener("keypress", HandleEnterKey);

    return () => window.removeEventListener("keypress", HandleEnterKey);
  });
  const navigate = useNavigate();
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });

  return (
    <div>
      <EmptyBox />
      <BasicArea
        inputValue={props.inputs.barcodeValue}
        onInputChange={(e) => {
          props.setInputs({
            ...props.inputs,
            barcodeValue: e,
          });
        }}
        switchValue={props.inputs.switchValue}
        onSwitchChange={(e) => {
          props.setInputs({
            ...props.inputs,
            switchValue: e,
          });
        }}
        onInputKeyDown={(e) => {
          if (props.inputs.barcodeValue.length === 10) {
            props.WoNoSearch();
          } else {
            setSnackbars({
              toggle: true,
              type: "error",
              message: "Barcode번호를 확인해주세요",
            });
          }
        }}
        autoFocus={true}
      />
      <Card
        wrapStyle={{
          height: "35vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        {props.modalToggle && (
          <ul className="tab_nav" style={{ marginTop: "5px" }}>
            <li>
              <a
                className={props.tabToggle ? "" : "active"}
                onClick={() => props.setTabToggle(false)}
              >
                {props.lanData.length > 0
                  ? props.lanData.filter(
                      (f) =>
                        f.lanId === "Fom_WorkInInformation" &&
                        f.lanType === "FORM"
                    )[0].lanName
                  : ""}
              </a>
            </li>
            <li>
              <a
                className={!props.tabToggle ? "" : "active"}
                onClick={() => props.setTabToggle(true)}
              >
                {props.lanData.length > 0
                  ? props.lanData.filter(
                      (f) =>
                        f.lanId === "Fom_MaterialInInformation" &&
                        f.lanType === "FORM"
                    )[0].lanName
                  : ""}
              </a>
            </li>
          </ul>
        )}
        <CardH3 name="작업정보" />
        {/* <BasicCombo
          style={{ marginRight: "38px" }}
          containerStyle={{ flexWrap: "noWrap" }}
          name="자재품명"
          combos={props.inputs.bomItemList}
          value={props.inputs.bomItemNm}
          onChange={(e) => {
            props.setInputs({
              ...props.inputs,
              bomItemNm: e,
            });
          }}
          disabled={true}
        /> */}
        <BasicInput
          containerStyle={{ flexWrap: "noWrap", width: "300px" }}
          name="주문수량"
          value={props.inputs.SoQty}
          onChange={(e) => {
            props.setInputs({
              ...props.inputs,
              bomSoQty: e.target.value,
            });
          }}
          disabled={true}
        />
        <BasicInput
          containerStyle={{ flexWrap: "noWrap", width: "300px" }}
          name="지시수량"
          value={props.inputs.OrderQty}
          onChange={(e) => {
            props.setInputs({
              ...props.inputs,
              bomOrderQty: e.target.value,
            });
          }}
          disabled={true}
        />
        <BasicInput
          containerStyle={{ flexWrap: "noWrap", width: "300px" }}
          name="생산수량"
          value={props.inputs.WorkQty}
          onChange={(e) => {
            props.setInputs({
              ...props.inputs,
              bomWorkQty: e.target.value,
            });
          }}
          disabled={true}
        />
      </Card>
      <Card
        wrapStyle={{
          minHeight: "35vh",
        }}
      >
        {/* <CardH3 name="생산정보" /> */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
          }}
        >
          {/* <BasicInput
            containerStyle={{ flexWrap: "noWrap" }}
            name="시작일"
            value={props.inputs.workStartDt}
            onChange={(e) => {
              props.setInputs({
                ...props.inputs,
                workStartDt: e.target.value,
              });
            }}
            disabled={true}
          />
          <BasicInput
            containerStyle={{ flexWrap: "noWrap" }}
            name="종료일"
            value={props.inputs.workEndDt}
            onChange={(e) => {
              props.setInputs({
                ...props.inputs,
                workEndDt: e.target.value,
              });
            }}
            disabled={true}
          /> */}
          <CardH3 name="작업지시정보" />
          <BasicInput
            containerStyle={{ flexWrap: "noWrap", width: "300px" }}
            name="거래처"
            value={props.inputs.custNm}
            onChange={(e) => {
              props.setInputs({
                ...props.inputs,
                custNm: e.target.value,
              });
            }}
            disabled={true}
          />
          <BasicInput
            containerStyle={{ flexWrap: "noWrap", width: "300px" }}
            name="제품품명"
            value={props.inputs.itemNm}
            onChange={(e) => {
              props.setInputs({
                ...props.inputs,
                itemNm: e.target.value,
              });
            }}
            disabled={true}
          />
        </div>
      </Card>
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </div>
  );
}

export default MM10070;
